
import { Dropdown, IDropdownOption } from "@fluentui/react";
import { useState } from "react";
import { IDropDownCellProps } from "./IDropDownCellProps";
import { UIControlsText } from "../../../content/UIControlsText";
import React from "react";
import { PageStyles } from "../../../pages/pricingprogram/CPStrategic/content/Page.InternalPricingProgram.Styles";
import { SessionStorageConsts } from "../../../models/SessionStorageConsts";
import { getEntityDataFromSession, getRuleValidationMessage } from "../common/util";
import { MessageTypeText } from "../../../models/MessageTypeText";
import { GRID_COL_INDEX_ATTRIBUTE } from "@progress/kendo-react-grid";
import { useTableKeyboardNavigation } from "@progress/kendo-react-data-tools";
import { JavaScriptExtensions } from "../../../infrastructure/JavaScriptExtensions";

/**
 * DropDownGridCell component.
 * @function component
 */
export const DropDownGridCell = (props: IDropDownCellProps) => {

    const [values, setValues] = useState(props.selectedValues || []); 
    const sessionResourceData = getEntityDataFromSession<any>(SessionStorageConsts.resourceStrings);
    const navigationAttributes = useTableKeyboardNavigation(props.gridCellProps?.id || "", !!props.gridCellProps);
    const cellAttributes = props.gridCellProps ? {
        role: "gridcell",
        "aria-colindex": props.gridCellProps.ariaColumnIndex,
        "aria-selected": props.gridCellProps.isSelected,
        colSpan: props.gridCellProps.colSpan,
        className: props.gridCellProps.className,
        style: props.gridCellProps.style,
        [GRID_COL_INDEX_ATTRIBUTE]: props.gridCellProps.columnIndex,
        ...navigationAttributes
    } : {};
    const positionId = props.gridCellProps ? `${props.gridCellProps.id}-position` : undefined;
    const positionDescription = props.gridCellProps && (
        <span id={positionId} hidden>
            {JavaScriptExtensions.stringFormat(
                getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "GridCellPosition", UIControlsText.GridCellPosition),
                `${props.ariaRowIndex ?? props.gridCellProps.dataIndex + 2}`,
                `${props.gridCellProps.ariaColumnIndex}`
            )}
        </span>
    );
    
    /**
     * Event to handle dropdown updates
     * @method
     * @param {IDropdownOption} item Updated dropdown selection 
     */
    const dropdownChange = (event: React.FormEvent<HTMLDivElement>, item?: IDropdownOption): void => {
        if (item) {
            if (props.isMultiSelect) {
                setValues((prevState: IDropdownOption[]) => {
                    let newState = item.selected ? [...prevState, item] : prevState.filter(x => x.key !== item.key);
                    props.itemSelectionUpdate && props.itemSelectionUpdate(props.cellId, newState);
                    return newState;
                });
            }
            else {
                if(props.isUploadedRecord != false){
                    setValues([item.key]);
                    props.itemSelectionUpdate && props.itemSelectionUpdate(props.cellId, [item.key]);
                }
            }
           
        }
    }

    return (
        <React.Fragment>
            {props.isMultiSelect &&
                <td {...cellAttributes}>
                    <Dropdown
                        aria-label={props.ariaLabel || getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "DropdownText", UIControlsText.DropdownText)}
                        aria-describedby={positionId}
                        multiSelect
                        onChange={dropdownChange}
                        options={props.data}
                        selectedKeys={values.map(i => i.key)}
                    />
                    {positionDescription}
                </td>
            }
            {!props.isMultiSelect &&
                <td {...cellAttributes}>
                    <Dropdown
                    aria-label={props.ariaLabel || getRuleValidationMessage(sessionResourceData, MessageTypeText.FieldLabelText, "DropdownText", UIControlsText.DropdownText)}
                    aria-describedby={positionId}
                    onChange={dropdownChange}
                    options={props.data}
                    selectedKey={values[0]}
                    styles={PageStyles.gridCellDropDownStyles}
                    />
                    {positionDescription}
                </td>
            }
        </React.Fragment>
    )
}
export default DropDownGridCell;